import QrCodesTable from './QrCodesTable/QrCodesTable';

export default QrCodesTable;
